// ----------------------------------------------------------------------

function path(root: string, subLink: string) {
  return `${root}${subLink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: path(ROOTS_AUTH, '/login'),
  forgotPassword: path(ROOTS_AUTH, '/forgot-password'),
  setPassword: path(ROOTS_AUTH, '/set-password'),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  app: path(ROOTS_DASHBOARD, '/dashboard'),
  dashboard: path(ROOTS_DASHBOARD, '/dashboard'),
  employees: path(ROOTS_DASHBOARD, '/members'),
  employeeList: path(ROOTS_DASHBOARD, '/members/employees'),
  employeeDetail: path(ROOTS_DASHBOARD, '/members/employees/details'),
  candidateList: path(ROOTS_DASHBOARD, '/members/candidates'),
  candidateDetail: path(ROOTS_DASHBOARD, '/members/candidates/details'),
  internList: path(ROOTS_DASHBOARD, '/members/interns'),
  internDetail: path(ROOTS_DASHBOARD, '/members/interns/details'),
  IntervieweeList: path(ROOTS_DASHBOARD, '/members/interviewee'),
  leaves: path(ROOTS_DASHBOARD, '/leaves'),
  leaveDetail: path(ROOTS_DASHBOARD, '/leaves/detail'),
  leaveManagement: path(ROOTS_DASHBOARD, '/leaves/leaveManagement'),
  leaveEmployee: path(ROOTS_DASHBOARD, '/leaves/leaves'),
  landingPage: path(ROOTS_DASHBOARD, '/landingPage'),
  testimonial: path(ROOTS_DASHBOARD, '/landingPage/testimonial'),
  portfolio: path(ROOTS_DASHBOARD, '/landingPage/portfolio'),
  projects: path(ROOTS_DASHBOARD, '/projects'),
  subProjects: path(ROOTS_DASHBOARD, '/projects/projects'),
  projectDetail: path(ROOTS_DASHBOARD, '/projects/details'),
  taskBoard: path(ROOTS_DASHBOARD, '/taskManagement/taskBoard'),
  tasksList: path(ROOTS_DASHBOARD, '/taskManagement/tasks'),
  overdueTaskList: path(ROOTS_DASHBOARD, '/taskManagement/overdueTasks'),
  config: path(ROOTS_DASHBOARD, '/config'),
  designationList: path(ROOTS_DASHBOARD, '/config/designations'),
  departmentList: path(ROOTS_DASHBOARD, '/config/departments'),
  addMember: path(ROOTS_DASHBOARD, '/config/add-member'),
  roleList: path(ROOTS_DASHBOARD, '/config/roles'),
  documents: path(ROOTS_DASHBOARD, '/documents'),
  offerLetter: path(ROOTS_DASHBOARD, '/documents/offerLetter'),
  compensationLetter: path(ROOTS_DASHBOARD, '/documents/compensation'),
  holidaysList: path(ROOTS_DASHBOARD, '/holiday'),
  clients: path(ROOTS_DASHBOARD, '/client'),
  clientDetail: path(ROOTS_DASHBOARD, '/client/details'),
  assets: path(ROOTS_DASHBOARD, '/assets'),
  assetsDetail: path(ROOTS_DASHBOARD, '/assets/details'),
  myProfile: path(ROOTS_DASHBOARD, '/my-profile'),
  reviews: path(ROOTS_DASHBOARD, '/reviews'),
  addEmployee: path(ROOTS_DASHBOARD, '/add-employee'),
  employeeDashboard: path(ROOTS_DASHBOARD, '/dashboard'),
  reviewDetail: path(ROOTS_DASHBOARD, '/reviews/details'),
  taskDetail: path(ROOTS_DASHBOARD, '/tasks/details'),
  taskManagement: path(ROOTS_DASHBOARD, '/taskManagement'),
  eta: path(ROOTS_DASHBOARD, '/taskManagement/eta'),
};
